<template>
  <div id="questions" class="page-questions g-main">
    <!-- 有数据 -->
    <template v-if="!inAppNoLogin">
    <div class="tab-con">
      <router-link :to="'/' + '?hideNav=1'"><span class="on" href="javascript:;">提问</span></router-link>
      <router-link :to="'/lists/' + '?hideNav=1'"><span href="javascript:;" :class="{ new: isShowNewMessage }">服务历史</span></router-link>
    </div>

    <div class="page-con page-scrollview">
      <div class="newinfo-con" v-if="isShowNewMessage" @click="goService">您的提问被回复了，快去看看吧 <span>></span></div>

      <div class="banner-con">
        <img src="./../assets/images/banner.png" v-if="noLogin"/>
        <img :src="bannerUrl" v-else/>
      </div>

      <div class="time-con">
        {{ onlineTime }}
      </div>

      <div class="questions">
        <!-- 问题编辑 -->
        <div class="questions-con" :class="questionStatus">
          <h2>病情描述</h2>
          <textarea name="describe" id="describe" cols="30" rows="1" class="border1" v-model="describe" placeholder="请详细描述您的问题和身体状况，便于医生更准确的分析判断，宝宝树将确保您的隐私安全，仅供本次咨询使用。夜间提问，回复可能延迟。专家回答仅为建议，具体诊疗请前往医院进行，感谢您的支持和理解，谢谢！"></textarea>
          <span class="num">{{ question.count }}/500</span>
          <div class="tips" v-if="questionStatus == 'less'">问题描述少于10个字，请详细描述后再提交</div>
          <div class="tips" v-if="questionStatus == 'sensitive'">问题描述包含违规或敏感词， 请重新描述后提交</div>
          <div class="tips" v-if="questionStatus == 'more'">问题描述超过500个字，请缩减描述后再提交</div>
        </div>

        <p class="tips">*该图片用于本次咨询，仅医生可见（可上传9张图片）</p>

        <!-- 图片上传 -->
        <div class="img-upload clearfix">
          <template >
            <draggable :list="imgs" @update="datadragEnd">
              <div v-for="(item, index) in imgs" class="dragDiv" :key="index">
                <div class="img" :key="index">
                  <img class="preview-img" :src="item.src1" @click="preview(index)">
                  <i class="close" @click="deleteImg(index)"></i>
                </div>
              </div>
            </draggable>
          </template>

          <div v-if="isShowUpload" class="upload needsclick" @click.self="upload" data-track="yy_djk_kwys_twtpsc">
            <form class="hidden-form" enctype="multipart/form-data">
              <input class="needsclick" ref="imageInput" type="file" accept="image/*" @change="fileUploadChange" name="image" multiple="multiple">
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <!--如果未开通会员并且快问设置了会员权益-->
    <div class="bottom-bar new-bottom-bar border5" v-if="!memberState && goodsVipInfo && Number(goodsVipInfo.skuBenefitType) === 1">
      <div class="new-btn-con">
         <NewBtn size="large" :priceInfo="priceInfo" :vipOpenText='constantData' :price="price" :otherPrice="goodsVipInfo.otherPrice" :type="btnStatus" :disabled="btnStatus !== 'normal'" track="yy_djk_kwys_ljwys" @bindOriginSubmit="submit" @bindVipSubmit="bindVip">
         </NewBtn>
      </div>
    </div>
    <div class="bottom-bar border5" v-else>
      <div class="btn-con">
        <Btn size="large" :type="btnStatus" :disabled="btnStatus !== 'normal'" track="yy_djk_kwys_ljwys" @click.native="submit">
          <span v-if="memberState && goodsVipInfo && Number(goodsVipInfo.skuBenefitType) === 1">¥{{ goodsVipInfo.otherPrice }}</span>
          <span v-else>¥{{ price }}</span>
          立即问医生
          <p class="free" v-if="priceInfo && priceInfo.freeCount !== '0'">本次免费 剩余{{priceInfo.freeCount}}次</p>
        </Btn>
      </div>
    </div>

    <!-- 提示弹层 -->
    <div class="popup popup-tips">
      <Popup v-model="isTips" position="center" width="70%">
        <h3>使用须知</h3>
        <p class="txt">快问医生，一款快速且能多次互动的健康咨询产品，医生一般会在1小时内回复您的咨询，但医生所提供内容均是健康咨询，不是诊疗，亦不可作诊疗依据，如您有诊疗需求，请前往医院，敬请理解。</p>
        <p style="text-align: center">
          <Btn @click.native="isRead">我知道了</Btn>
        </p>
        <a href="javascript:;" class="btn-close border-blue" @click="isRead">X</a>
      </Popup>
    </div>

    <!-- 支付弹层 -->
    <div class="popup popup-pay">
      <template v-if="!supportShubi">
        <Popup v-model="isPay" position="bottom" width="100%" height="auto" @popupcose="goService">
          <h3>支付方式</h3>
          <div class="con">
            <ul>
              <li class="border4" v-for="(item, index) in payList" :key="index">
                <i class="icon" :class="'icon-' + item.payWayType"></i>
                <span>{{ item.name }}</span>
                <a @click="select(item.id)" href="javascript:;" class="btn-select" :class="item.id === paywayid ? 'on' : ''"></a>
              </li>
            </ul>
            <Btn type="primary" size="large" @click.native="pay" track="yy_djk_kwys_qrzf">确认支付</Btn>
          </div>
          <a href="javascript:;" class="btn-close border-blue" @click="goService">X</a>
        </Popup>
      </template>
      <payComp :oldPrice="price" :orderCode="orderCode" @paySuccess="paySuccess" ref="payComp"  v-else />
    </div>
  </template>

    <!-- 没有数据 -->
    <template>
      <template v-if="!inAppNoLogin">
        <Popup v-model="noLogin" position="bottom" width="100%" height="2rem">
        <div class="no-login">
          <Btn type="primary" size="large" @click.native="goQuestion">
            <span v-if="!isLogin">立即登录问医生</span>
          </Btn>
        </div>
        </Popup>
      </template>
      <div class="no-data" v-else>
        <img src="./../assets/images/no-data.png"/>
        <p>暂无服务</p>
        <div>购买过的服务将显示在这里</div>
        <Btn type="primary" size="large" @click.native="goQuestion">
          <span v-if="!isLogin">立即登录</span>
        </Btn>
       </div>
    </template>

    <!-- 用户协议 -->
    <div class="popup popup-protocol">
      <Popup v-model="isProtocol" position="bottom" width="100%" height="100%">
        <h3>用户协议</h3>
        <div class="con">
          <div>
            <p>“快问医生”使用规则</p>
            <p>“快问医生”为您和医生之间的付费健康咨询平台。在您向医生支付咨询费用前，请详细阅读本使用规则。</p>
            <h4>一、服务</h4>
            <p>1、本服务所称“咨询”特指您通过“快问医生”提交问题并支付费用后，“快问医生”将您提交的问题随机分配给“快问医生”合作方的医生（ 以下简称“医生”），由医生认领问题并进行回复。</p>
            <p>2、在您提交问题时以及与医生对话过程中，请您不要披露您的真实个人信息，如您仍披露的，视为您同意披露；并且您提交问题时发布的文字或图片，系统指定医生可查看，如您不同意的，请您立即停止提交问题。</p>
            <p>3、每一问题，您发言后医生进行回复计为一次对话，您可在提交问题后【24】小时内与医生进行20次对话。请您特别注意，您提交的问题将在您提问已满【24】小时后（自您提交问题之时起算【24】小时）或您与医生已进行20次对话后关闭。</p>
            <p>4、如对话过程中，您偏离问题或者发言不符合言行要求，医生有权提醒您改正（此种情形下，医生的提醒视为医生回复），如您不改正的，医生有权【拒绝回复直至问题关闭】。</p>
            <p>5、您提交问题并支付费用，视为您向医生发出了不可撤销的合同要约，医生第一次回复时，方视为医生与您之间建立了合同关系；您了解并知悉，医生有完全的、自主的权利决定是否就您的问题进行第一次答复，如您提交问题后，超过1小时没有医生第一次回复，“快问医生”将在1-3个工作日内向您原路退还您已经支付的费用。</p>
            <p>6、建议您根据实际情况描述问题，并辅助图片说明，这样将提高您的问题获得医生第一次回复的机会。</p>
            <p>7、您了解医生仅能尽可能利用专业知识及临床经验给予您一定的解惑及帮助建议，不进行诊断或治疗，同时不对答复是否符合您的预期做保证。除另有明确说明外，您不得因为咨询服务中的内容不满意要求退款。</p>
            <h4>二、费用</h4>
            <p>1、每次咨询将收取您一定的费用，请您在付费前注意查看费用金额、使用提示等并审慎选择。</p>
            <p>2、您不可撤销地授权宝宝树代为收取您支付给医生的咨询费用，宝宝树将在咨询结束后按照与合作方的相关协议向合作方或医生支付费用。</p>
            <p>3、您了解并知悉，除另有明确说明外，任何情况下您均不得要求退款。</p>
            <h4>三、权利义务</h4>
            <p>1、如您对咨询不满意的，可向宝宝树提出投诉。</p>
            <p>2、如您与医生发生服务纠纷的，您可通过司法部门或行政部门依照法定程序要求宝宝树提供相关数据，宝宝树应积极配合并提供有关资料。</p>
            <p>3、在咨询过程中您发布的内容或提问必须遵守中国法律法规、行政规章以及规范性文件、遵守宝宝树公布的所有服务协议，并不得有以下行为：</p>
            <p>（1）发布以下内容：煽动抗拒、破坏宪法及法律法规实施的言论；煽动颠覆国家政权、破坏国家统一的言论；违背社会风俗和社会道德的言论；煽动民族仇恨、民族歧视，破坏民族团结的言论； </p>
            <p>（2）发布使用任何侮辱或毁谤他人，性骚扰，或对未成年人有不良影响的内容；</p>
            <p>（3）发布淫秽、色情、赌博、暴力、凶杀、恐怖、非法宗教或者教唆犯罪的内容； </p>
            <p>（4）发布广告等牟利性经营活动的内容；</p>
            <p>（5）发布侵犯第三方权利，特别是他人著作权、商标权等知识产权或者合法权利的内容；</p>
            <p>（6）发布要求医生进行诊断或治疗的内容；</p>
            <p>（7）其他根据宝宝树平台性质，不适宜发布的内容。</p>
            <p> 如您违反的，宝宝树有权视情况选择以下一种或几种措施：</p>
            <p>（1）立即对相应信息进行删除、屏蔽；</p>
            <p>（2）中止向您提供部分或全部服务；</p>
            <p>（3）查封您的账户，终止向您提供服务；</p>
            <p>（4）要求您赔偿损失（包括宝宝树自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿宝宝树的上述全部损失。</p>
            <p>3、您在咨询过程中应语言文明，尊重医生，平等交流。如有对医生恶意中伤，语言不文明，医生有权【拒绝回复直至问题关闭】，您无权要求退款。</p>
            <h4>四、免责</h4>
            <p>1、咨询中医生所提供内容均是个人建议，不得做为诊断、治疗的直接医疗处置依据，用户需知晓并同意诊断及治疗均需前往医院。擅自将医生建议做为处方使用的，后果自负。是否采信咨询中医生的意见为您的个人行为，“快问医生”及宝宝树不承担任何可能产生的责任。</p>
            <p>2、“快问医生”有权对您的注册数据及咨询的行为进行查阅，发现注册数据或咨询行为中存在任何问题或合理怀疑，均有权向您发出询问及要求改正的通知或者直接作出删除等处理。</p>
            <p>3、对于您在使用“快问医生”中的不当行为或其它任何“快问医生”认为应当终止服务的情况，“快问医生”有权随时作出删除相关信息、终止服务提供等处理，而无须征得您的同意。</p>
          </div>
        </div>
        <a href="javascript:;" class="btn-close border-blue" @click="closeProtocol">X</a>
      </Popup>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Cookies from 'js-cookie';
  import draggable from 'vuedraggable';
  import Btn from '../components/Btn';
  import NewBtn from '../components/NewBtn';
  import Popup from '../components/Popup';
  import payComp from '../components/payComp';
  import {submitForm} from './../stores/actions';
  import doLogin from '../lib/do-login';

  export default {
    name: 'questions',
    data() {
      return {
        isLogin: false,
        imageCount: 0,
        isTips: false,
        isPay: false,
        isShowUpload: true,
        isAsk: false,
        fixed: true,
        payList: [],
        // price: null,
        priceInfo: null,
        imgs: [],
        paywayid: 4,
        payData: {},
        interrogationId: null,
        orderCode: null,
        noLogin: false,
        inAppNoLogin: false
      };
    },
    components: {Btn, NewBtn, Popup, draggable, payComp},
    computed: {
      ...mapState([
        'isTip', 'isSlider', 'isLeave', 'question', 'isProtocol', 'price', 'bannerUrl', 'onlineTime', 'newMessageStaus', 'token', 'constantData', 'memberState', 'goodsVipInfo']),

      // 问题描述
      describe: {
        get() {
          return this.$store.state.question.describe;
        },
        set(value) {
          this.updateQuestion(value);
        }
      },

      // 问题状态（normal: 正常, disabled: 不可提交, less: 字数少, more: 字数多, sensitive: 描述违规）
      questionStatus() {
        return this.$store.state.question.status;
      },

      // 按钮状态（normal: 正常, disabled: 不可提交）
      btnStatus() {
        return this.$store.state.question.status === 'normal' ? 'normal' : 'disabled';
      },

      isShowNewMessage() {
        return parseInt(this.newMessageStaus, 10) > 0;
      },
      supportShubi() {
        const curserVersion = doLogin.getAppVersion();
        return window.isApp === 1 && curserVersion > 239;
      }
    },
    beforeCreate() {
      window.VM = this;

      // 更新顶部状态
      this.$store.dispatch('updateNav', {
        title: '快问医生',
        type: 'center'
      });

      if (!this.price) {
        this.$store.dispatch('getPriceNew').then((v) => {
          this.priceInfo = v.data;
        });
      }
      // 避免运营配置快问链接时添加参数autoRefresh=1 如果添加了则将链接中去除autoRefresh=1
      const hreurl = window.location.href;

      const hasAutoRefresh = new RegExp('[\\?\\&]autoRefresh=1');

      if (hasAutoRefresh.test(hreurl)) {
        const newurl = hreurl.replace(hasAutoRefresh, '');
        window.location.href = newurl;
      }
    },
    created() {
      // 发埋点
      if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
        window.Tracking.initTrackUrl(2, 'djk_kwys_ym_tw', '');
      }
      const wxcode = this.$route.query.code;
      doLogin.bindAuth(wxcode, this.getWxAuth);

      // 登录
      this.$store.dispatch('login').then((v) => {
        if (v.err) {
          if (v.err === '用户过期，请重新登录') {
            this.isLogin = false;
            this.noLogin = true;
            if (window.isApp === 1) {
              this.inAppNoLogin = true;
            }
            doLogin.clearCookies();
            return false;
          }
          this.$dialog.Toast({mes: v.err});
        }

        if (!window.token) {
          this.noLogin = true;
          if (window.isApp === 1) {
            this.inAppNoLogin = true;
          }
          // window.mtlogin();
          return false;
        }
        this.getUserMemberInfo();
        this.isLogin = true;
        this.noLogin = false;
        this.inAppNoLogin = false;
        return true;
      });

      this.$store.dispatch('setLoading', false);
      // 如果没有绑定手机号去绑定手机号
      if (window.isHaveMobile === '0') {
        location.href = '//m.meitun.com/live/user/binding/';
      }
    },
    mounted() {
      // 进入页面提示
      this.noLogin = false;
      this.inAppNoLogin = false;
      if (window.MT && typeof window.MTsoftInputAdjustResize === 'function') {
        window.MT.softInputAdjustResize();
      }
      if (window.isApp === 1) {
        this.inAppNoLogin = true;
      }
      if (window.token) {
        this.isTips = !localStorage.protocol;
        this.noLogin = false;
        this.inAppNoLogin = false;
        this.updateStatus();
        // this.getUserMemberInfo();
      }
    },
    watch: {
      token: {
        handler() {
          this.inAppNoLogin = false;
          this.noLogin = false;
          // this.getUserMemberInfo();
          this.$store.dispatch('setLoading', false);
        },
        deep: true
      }
    },
    updated() {
      // this.$store.dispatch('setLoading', false);
    },

    destroyed() {
      this.$store.dispatch('updateQuestion', '');
      clearInterval(this.rn); // 清除轮询的定时器
    },

    beforeRouteLeave(to, from, next) {
      clearInterval(this.rn); // 清除轮询的定时器
      next();
    },

    methods: {
      // 去快问页面
      goQuestion() {
        if (!window.token || !this.isLogin) {
          // 如果没有登录
          const wxcode = this.$route.query.code;
          doLogin.login(wxcode, this.getWxAuth);
        } else {
          // 登录成功
          this.$router.push({path: '/?hideNav=1'});
          if (!window.isHaveMobile) {
            location.href = '//m.meitun.com/live/user/binding/';
          }
        }
      },

      // 已读使用须知
      isRead() {
        localStorage.protocol = true;
        this.isTips = false;
      },

      lookProtocol() {
        this.$store.dispatch('lookProtocol', true);
      },

      // 关闭协议
      closeProtocol() {
        this.$store.dispatch('lookProtocol', false);
      },

      // 关闭支付，去服务列表
      goService() {
        // 发埋点
        if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
          window.Tracking.initTrackUrl(2, 'djk_kwys_ym_zfgb', '');
        }
        this.isPay = false;
        this.$router.push('/lists/?hideNav=1');
      },

      // 提交问题，进入支付
      submit() {
        // 小于 10 个字
        if (this.$store.state.question.count < 10) {
          this.$store.dispatch('updateQuestionStatus', {
            status: 'less'
          });
          return false;
        }

        this.$store.dispatch('setLoading', true);

        if (!this.isAsk) {
          this.isAsk = true;
          const obj = [
            {
              type: 'text',
              text: this.question.describe
            }
          ];

          if (!this.price) {
            this.$dialog.Toast({mes: '获取价格失败，请重新页面重试！'});
            this.$store.dispatch('setLoading', false);
            return false;
          }

          // 如果上传了图片的话
          if (this.imgs.length > 0) {
            this.imgs.forEach((element) => {
              obj.push({
                type: 'image',
                file: element.src2
              });
            });
          }

          // 创建问题
          let isfree = false;
          if (this.priceInfo && this.priceInfo.hasFree !== '0') {
            isfree = true;
          }

          this.$store.dispatch('createQuestion', {
            type: 3,
            paywayid: this.paywayid,
            amount: this.price,
            content: JSON.stringify(obj),
            interrogationId: '', // FIXME: 是否需要，目前没有再次编辑的功能
            isfree  // 转成boolen类型
          }).then((v) => {
            this.$store.dispatch('setLoading', false);
            if (v.err) {
              this.$dialog.Toast({mes: v.err});
              this.isAsk = false;
              return false;
            }

            this.payData = v.data;
            this.interrogationId = v.data.interrogationId; // 问题id
            this.orderCode = v.data.orderCode; // 订单号

            if (this.priceInfo && this.priceInfo.hasFree === '1') {
              // 有免费资格，直接去详情页
              this.$router.push(`/detail/${this.$data.interrogationId}?hideNav=1`);
            } else {
              // 无，弹出支付列表
              this.getPayList();
            }
            return true;
          });
        } else {
          this.$store.dispatch('setLoading', false);
          this.$router.push({name: 'index'});
        }
        return true;
      },
      // 点击VIP按钮
      bindVip() {
        // 如果用户未开通会员权益,点击跳转到开通会员页
        const version = 232; // 会员开通页面支持的版本号 2.3.2
        const curserVersion = doLogin.getAppVersion();
        if (window.isApp === 1 && curserVersion < version) {
          location.href = '//m.meitun.com/live/update-tip.html?mtoapp=0&mtomeitun=0';
        } else {
          location.href = '//m.meitun.com/my/plus/buy/index.html?source=4';
        }
      },

      // 获取支付列表
      getPayList() {
        // 新增曝光埋点
        if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
          window.Tracking.initTrackUrl(2, 'djk_kwys_tw_payType_show', '');
        }
        this.$store.dispatch('getPay', {
          type: 3
        }).then((v) => {
          if (v.err) {
            this.$dialog.Toast({mes: v.err});
            return false;
          }
          if (!Cookies.get('MT_USER_INFO')) {
            const ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('micromessenger') !== -1) {
              // 微信环境，只能选择微信支付
              v.data.payWayList.forEach((payway) => {
                if (payway.id === 4) {
                  this.payList = [payway];
                }
              });
              // this.payList = v.data.payWayList.slice(0, 1);
            } else {
              // 非微信环境，只能选择支付宝支付
              v.data.payWayList.forEach((payway) => {
                if (payway.id === 1) {
                  this.payList = [payway];
                }
              });
              // this.payList = v.data.payWayList.slice(1);
            }
            this.paywayid = this.payList[0].id; // 默认第一个
          } else {
            this.payList = v.data.payWayList;
            if (this.supportShubi) {
              this.$refs.payComp.handleClickShowPayBox();
              return true;
            }
          }
          // 创建成功，弹出支付列表
          this.isPay = true;
          return true;
        });
      },

      // 选择支付类型
      select(id) {
        this.paywayid = id;
      },

      // 确认支付，唤醒支付
      pay() {
        if (!this.paywayid) {
          this.$dialog.Toast({mes: '请选择支付方式！'});
          return false;
        }
        // 发埋点
        if (!window.Tracking || typeof window.Tracking.initTrackUrl !== 'function') {
          console.log('不能发埋点');
        } else if (this.paywayid === 4) {
          window.Tracking.initTrackUrl(2, 'yy_djk_kwys_wx', '');
        } else if (this.paywayid === 1) {
          window.Tracking.initTrackUrl(2, 'yy_djk_kwys_zfb', '');
        }

        if (window.MT) {
          window.MT.gotoPayWithPaywayid(this.orderCode, this.paywayid);
        } else if (!Cookies.get('MT_USER_INFO')) {
          const openid = JSON.parse(Cookies.get('userInfo')).weixinUserInfo ? JSON.parse(Cookies.get('userInfo')).weixinUserInfo.openid : '';
          this.$store.dispatch('getH5ReqMsg', {
            ordercode: this.orderCode,
            paywayid: this.paywayid,
            singleWap: 1,
            wappayresultpage: 'http://m.meitun.com/inquiry/lists/?hideNav=1',
            quiturl: 'http://m.meitun.com/inquiry/lists/?hideNav=1',
            openId: openid,
            weixinappcode: 'wx5699bb5297ae3984'
          }).then((res) => {
            if (res.rtn_code === '0') {
              const data = res.data;
              let params;
              const ua = navigator.userAgent.toLowerCase();
              if (ua.indexOf('micromessenger') !== -1) {
                // 微信环境
                params = {
                  appId: data.appid,               // 公众号名称，由商户传入
                  timeStamp: data.timeStamp,       // 时间戳，自1970年以来的秒数
                  nonceStr: data.noncestr,         // 随机串
                  package: data.wxPackage,
                  signType: data.signType,         // 微信签名方式：
                  paySign: data.signedinfo,
                  returnUrl: encodeURIComponent('//m.meitun.com/inquiry/lists/?hideNav=1'),
                  backUrl: encodeURIComponent('//m.meitun.com/inquiry/lists/?hideNav=1')
                };
                location.href = `//m.meitun.com/live/info/weixin?appid=${params.appId}&timeStamp=${params.timeStamp}&noncestr=${params.nonceStr}&wxPackage=${params.package}&signType=${params.signType}&signedinfo=${params.paySign}&returnUrl=${params.returnUrl}&backUrl=${params.backUrl}`;
              } else if (this.paywayid === 4) {
                this.$dialog.Toast({mes: '非微信环境只能使用支付宝支付'});
              } else {
                params = {
                  sign: data.sign,
                  sec_id: data.secId,
                  v: data.v,
                  req_data: data.reqData,
                  service: data.service,
                  partner: data.partner,
                  format: data.format
                };
                submitForm(data.actionUrl, params);
              }
            } else {
              console.log(res.rtn_msg);
            }
          });
        }

        return true;
      },

      // 触发选择图片
      upload() {
        // TODO: 针对安卓用户，统一走原生调用
        const userAgent = window.navigator.userAgent;
        const index = userAgent.indexOf('Android');

        if (index >= 0 && window.isApp === 1) {
          // android
          window.MT.catchImage(960, 960);

          // 上传成功回调方法
          window.catchFileFinishCall = (base64) => {
            const formData = new FormData(document.querySelector('.hidden-form'));

            // 上传 base64
            window.VM.$store.dispatch('uploadImageBase64', {
              formData,
              url: '/mobile/system/uploadbase64picture.htm',
              type: 'post',
              base64
            }).then((response) => {
              // 判断是否成功
              if (Number.parseInt(response.resultInfo.code, 10) !== 0) {
                this.$dialog.Toast({mes: response.resultInfo.message});
              } else {
                // 将图片添加到数组
                this.imgs.push({
                  src: response.data.imageUrl,
                  w: 0,
                  h: 0,
                  index: this.imageCount,
                  src1: response.data.imageThumb,
                  src2: response.data.imageUri
                });

                // 等于 9 张，隐藏上传按钮
                if (this.imgs.length === 9) {
                  this.isShowUpload = false;
                }
              }
            });
          };
        } else {
          // ios
          const $fileInput = this.$refs.imageInput;
          $fileInput.click();
          return true;
        }
        return true;
      },

      // 选择图片
      fileUploadChange(e) {
        // 获取File对象，这里是上传单张图片，【0】代表第一张图片，如果是多张，就是var file = e.target.files;
        // 判断上传图片的个数
        if ((9 - this.imgs.length) < e.target.files.length) {
          this.$dialog.Toast({mes: '你选择的图片数量过多,请重新选择'});
          return;
        }

        // 刚好 9 张，隐藏长上传按钮
        if ((9 - this.imgs.length) === e.target.files.length) {
          this.isShowUpload = false;
        }

        const form = new FormData(document.querySelector('.hidden-form'));
        this.imageUpload(form);
        e.target.value = '';
      },

      // 手动改图片顺序
      datadragEnd(evt) {
        console.log(evt.oldIndex);
        console.log(evt.newIndex);
        console.log(this.imgs.map(e => e.id));
      },

      // 上传图片
      imageUpload(formData) {
        let isOverTime = false;
        let overTime = setTimeout(() => {
          this.$dialog.Toast({mes: '图片上传超时'});
          overTime = null;
          isOverTime = true;
        }, 30000);

        this.$store.dispatch('uploadImageByForm', {
          formData,
          url: '/mobile/system/uploadpictures.htm?imagewidth=120&imageheight=120',
          type: 'post'
        }).then((response) => {
          if (isOverTime) {
            return;
          }
          clearTimeout(overTime);
          overTime = null;

          // 判断是否成功
          if (Number.parseInt(response.resultInfo.code, 10) !== 0) {
            this.$dialog.Toast({mes: response.resultInfo.message});
          } else {
            response.data.imageUrl.forEach((item, index) => {
              this.imgs.push({
                src: response.data.imageSource[index],
                w: 0,
                h: 0,
                index: this.imageCount,
                src1: item,
                src2: response.data.imagestr[index]
              });
              this.imageCount += 1;
            });
          }
        });
      },

      preview(clickIndex) {
        window.VM.$preview.open(clickIndex, this.imgs);
      },
      // 更新问题状态
      updateQuestion(value) {
        this.$store.dispatch('updateQuestion', value);
      },

      // 删除图片
      deleteImg(index) {
        const self = this;

        self.$dialog.Confirm({
          mes: '确认删除？',
          opts: [
            {
              txt: '确定',
              color: true,
              callback: () => {
                self.imgs.splice(index, 1);
                self.$dialog.Toast({mes: '删除成功', timeout: 500});
                this.isShowUpload = true;
              }
            },
            {
              txt: '取消',
              color: false,
              callback: () => {
                self.$dialog.Toast({mes: '你点了取消', timeout: 500});
              }
            }
          ]
        });
      },

      // 定时轮询前 20 条数据状态
      updateStatus() {
        this.rn = setInterval(() => {
          this.$store.dispatch('getPriceNew').then((v) => {
            this.$store.dispatch('setNewMessage', v.data.newMsgCount);
          });
        }, 12000);
      },
      // 微信授权
      getWxAuth() {
        this.$store.dispatch('wxAuth', {
          code: this.$route.query.code,
          platformType: 5
        }).then((v) => {
          if (v.rescode.code === '0') {
            const userInfo = v.user[0];
            userInfo.weixinUserInfo = v.weixinUserInfo;
            doLogin.info(JSON.stringify(userInfo), userInfo.token); // 存储授权成功后的信息
            window.token = userInfo.token;
            this.$store.dispatch('setToken', userInfo.token);
            window.ajaxHeader.token = userInfo.token;
            this.$store.dispatch('setLoading', true);
            this.getUserMemberInfo();
          } else {
            this.$dialog.Toast({mes: v.rescode.info});
          }
        });
      },
      // 查询会员信息
      getUserMemberInfo() {
        // 微信授权成功后 查询会员信息
        this.$store.dispatch('getUserMemberInfo').then((info) => {
          if (info.rtn_code === '0') {
            const member = info.data;
            const userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
            userInfo.member = member;
            const token = userInfo.token;
            doLogin.info(JSON.stringify(userInfo), token); // 存储授权成功后的信息
          } else {
            this.$dialog.Toast({mes: info.rtn_msg});
          }
        });
      },
      paySuccess(status, msg) {
        payCallback(status ? 'true' : 'false', this);
        console.log(msg);
      }
    }
  };

  let count = 0;

  function updatePayStatus() {
    // 支付成功，定时查看状态
    window.VM.$store.dispatch('getQuestionDetail', {
      interrogationid: window.VM.$data.interrogationId,
      code: window.VM.$data.orderCode
    }).then((response) => {
      if (Number.parseInt(response.rtn_code, 10) !== 0) {
        // 获取详情失败
        window.VM.$dialog.Toast({mes: response.rtn_tip});
      }

      // 发送成功了，拉取最新的消息，并滚动到消息列表底部
      if (Number.parseInt(response.data.status, 10) === 0) {
        count += 1;
        if (count === 3) {
          // 发起3次请求，跳转到详情页
          window.VM.$dialog.Confirm({
            mes: '支付成功！',
            opts: [
              {
                txt: '确定',
                color: true,
                callback: () => {
                  ((self) => {
                    self.$data.isPay = true;
                    self.$router.push(`/detail/${self.$data.interrogationId}?hideNav=1`);
                  })(window.VM);
                }
              }
            ]
          }).call(window.VM);
        } else {
          updatePayStatus();
        }
      } else {
        // 状态更新，跳转到详情页
        window.VM.$dialog.Confirm({
          mes: '支付成功！',
          opts: [
            {
              txt: '确定',
              color: true,
              callback: () => {
                ((self) => {
                  self.$data.isPay = true;
                  self.$router.push(`/detail/${self.$data.interrogationId}?hideNav=1`);
                })(window.VM);
              }
            }
          ]
        }).call(window.VM);
      }
    });
  }

  // 支付回调
  function payCallback(str, self) {
    window.VM = self || window.VM;
    if (str === 'true') {
      updatePayStatus();
    } else {
      window.VM.$dialog.Confirm({
        mes: '支付失败！',
        opts: [
          {
            txt: '确定',
            color: true,
            callback: () => {
              console.log('失败');
            }
          }
        ]
      });
    }
  }

  window.payCallback = payCallback;
</script>

<style  lang="less" src="./../assets/questions.less"></style>



// WEBPACK FOOTER //
// Questions.vue?37f21e2f